// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ValidationQuestionsAnsweredSubscriptionVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type ValidationQuestionsAnsweredSubscription = { __typename?: 'Subscription', household: { __typename?: 'Household', id: string, validationQuestionsAnsweredAt?: Time | null } };

export const Operations = {
  Subscription: {
    ValidationQuestionsAnswered: 'ValidationQuestionsAnswered' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const ValidationQuestionsAnsweredDocument = gql`
    subscription ValidationQuestionsAnswered($householdId: ID!) {
  household(id: $householdId) {
    id
    validationQuestionsAnsweredAt
  }
}
    `;

/**
 * __useValidationQuestionsAnsweredSubscription__
 *
 * To run a query within a React component, call `useValidationQuestionsAnsweredSubscription` and pass it any options that fit your needs.
 * When your component renders, `useValidationQuestionsAnsweredSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidationQuestionsAnsweredSubscription({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useValidationQuestionsAnsweredSubscription(baseOptions: Apollo.SubscriptionHookOptions<ValidationQuestionsAnsweredSubscription, ValidationQuestionsAnsweredSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ValidationQuestionsAnsweredSubscription, ValidationQuestionsAnsweredSubscriptionVariables>(ValidationQuestionsAnsweredDocument, withSubscriptionIgnoreResults(options));
      }
export type ValidationQuestionsAnsweredSubscriptionHookResult = ReturnType<typeof useValidationQuestionsAnsweredSubscription>;
export type ValidationQuestionsAnsweredSubscriptionResult = Apollo.SubscriptionResult<ValidationQuestionsAnsweredSubscription>;